import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.BUILD_MINUTES,
  displayName: "Build Minutes",
  isCustomerFacing: false,
  cardConfig: {
    isTrial: () => false,
    icon: "build-minutes-icon",
    title: "Build Minutes",
    valueTransformer: (value) => {
      const formattedValue = Number(value).toLocaleString("en-US");
      return formattedValue + " Min/month ";
    },
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: Number(value).toLocaleString("en-US"),
        units: "Min",
      };
    },
  },
};

export default entitlement;
